import { ReviewsSortingOption } from '@headless-workspace/config';
import { ProductReview } from '../../../..';

export const filterReviewsLocally = (
    reviews: ProductReview[],
    selectedRatings: number[],
    sortingOption: ReviewsSortingOption,
): ProductReview[] => {
    let filtered = reviews;

    if (selectedRatings.length > 0) {
        filtered = filtered.filter((r) => selectedRatings.includes(r.rating));
    }

    switch (sortingOption) {
        case ReviewsSortingOption.MostRecent:
            filtered = filtered.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
            break;
        case ReviewsSortingOption.LeastRecent:
            filtered = filtered.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
            break;
        case ReviewsSortingOption.BestRated:
            filtered = filtered.sort((a, b) => b.rating - a.rating);
            break;
        case ReviewsSortingOption.WorstRated:
            filtered = filtered.sort((a, b) => a.rating - b.rating);
            break;
        default:
            break;
    }

    return filtered;
};
